<div
    class="header-area bg-white box-shadow transition"
    [ngClass]="{'active': isToggled}"
>
    <div class="d-md-flex align-items-center justify-content-between">
        <div class="header-left-side d-flex align-items-center">
            <div
                class="burger-menu position-relative transition lh-1"
                [ngClass]="{'active': isToggled}"
                (click)="toggle()"
            >
                <i-feather name="align-left"></i-feather>
            </div>
        </div>
        <ul class="header-right-side d-flex align-items-center m-0 p-0 list-unstyled">
<!--            <li>-->
<!--                <button-->
<!--                    mat-button-->
<!--                    (click)="toggleTheme()"-->
<!--                    class="dark-swtich-btn"-->
<!--                    [class.active]="toggleService.isDark()"-->
<!--                >-->
<!--                    <i-feather name="moon"></i-feather>-->
<!--                </button>-->
<!--            </li>-->
<!--            <li>-->
<!--                <button mat-button [matMenuTriggerFor]="messagesMenu" class="messages-menu-btn">-->
<!--                    <i-feather name="mail"></i-feather>-->
<!--                     <span class="trinta-badge fw-bold text-center text-white rounded-circle d-flex align-items-center justify-content-center">-->
<!--                        1-->
<!--                    </span> -->
<!--                </button>-->
<!--                <mat-menu class="messages-menu-dropdown" #messagesMenu="matMenu" xPosition="before">-->
<!--                    <div class="title d-flex align-items-center justify-content-between">-->
<!--                        <span class="fw-medium fs-16">-->
<!--                            Messages-->
<!--                            <span class="text-body fw-normal fs-15">-->
<!--                                (05)-->
<!--                            </span>-->
<!--                        </span>-->
<!--                        <a routerLink="/chat" class="link-btn fw-medium text-primary">-->
<!--                            Mark all as read-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <ul class="menu-body pl-0 mt-0 list-unstyled">-->
<!--                        <li class="position-relative">-->
<!--                            <img src="images/users/user1.jpg" class="rounded-circle position-absolute" alt="user">-->
<!--                            <span class="sub-title d-block fw-medium">-->
<!--                                Jacob Liwiski <span class="text-body fw-normal">35 mins ago</span>-->
<!--                            </span>-->
<!--                            <span class="message d-block text-body">-->
<!--                                Hey Victor! Could you please...-->
<!--                            </span>-->
<!--                            <a routerLink="/chat" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                            <span class="unread d-inline-block rounded-circle bg-primary position-absolute"></span>-->
<!--                        </li>-->
<!--                        <li class="position-relative">-->
<!--                            <img src="images/users/user2.jpg" class="rounded-circle position-absolute" alt="user">-->
<!--                            <span class="sub-title d-block fw-medium">-->
<!--                                Angela Carter <span class="text-body fw-normal">1 day ago</span>-->
<!--                            </span>-->
<!--                            <span class="message d-block text-body">-->
<!--                                How are you Angela? Would you...-->
<!--                            </span>-->
<!--                            <a routerLink="/chat" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                        </li>-->
<!--                        <li class="position-relative">-->
<!--                            <img src="images/users/user3.jpg" class="rounded-circle position-absolute" alt="user">-->
<!--                            <span class="sub-title d-block fw-medium">-->
<!--                                Brad Traversy  <span class="text-body fw-normal">2 days ago</span>-->
<!--                            </span>-->
<!--                            <span class="message d-block text-body">-->
<!--                                Hey Brad Traversy! Could you please...-->
<!--                            </span>-->
<!--                            <a routerLink="/chat" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                    <div class="menu-footer text-center">-->
<!--                        <a routerLink="/chat" class="text-primary text-decoration-underline d-inline-block fw-medium">-->
<!--                            View All Messages-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </mat-menu>-->
<!--            </li>-->
<!--            <li>-->
<!--                <button mat-button [matMenuTriggerFor]="notificationsMenu" class="notifications-menu-btn">-->
<!--                    <i-feather name="bell"></i-feather>-->
<!--                    <span class="trinta-badge fw-bold bg-primary text-center text-white rounded-circle d-flex align-items-center justify-content-center">-->
<!--                        1-->
<!--                    </span>-->
<!--                </button>-->
<!--                <mat-menu class="notifications-menu-dropdown" #notificationsMenu="matMenu" xPosition="before">-->
<!--                    <div class="title d-flex align-items-center justify-content-between">-->
<!--                        <span class="fw-medium fs-16">-->
<!--                            Notifications-->
<!--                            <span class="text-body fw-normal fs-15">-->
<!--                                (03)-->
<!--                            </span>-->
<!--                        </span>-->
<!--                        <a routerLink="/notifications" class="link-btn fw-medium text-primary">-->
<!--                            Clear All-->
<!--                        </a>-->
<!--                    </div>-->
<!--                    <ul class="menu-body p-0 mt-0 list-unstyled">-->
<!--                        <li class="position-relative">-->
<!--                            <div class="icon rounded-circle d-flex align-items-center justify-content-center position-absolute text-center transition">-->
<!--                                <i class="material-symbols-outlined">-->
<!--                                    sms-->
<!--                                </i>-->
<!--                            </div>-->
<!--                            <span class="sub-title d-block">-->
<!--                                You have requested to <strong class="fw-semibold">withdrawal</strong>-->
<!--                            </span>-->
<!--                            <span class="time d-block text-body">-->
<!--                                2 hrs ago-->
<!--                            </span>-->
<!--                            <a routerLink="/notifications" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                            <span class="unread d-inline-block rounded-circle bg-primary position-absolute"></span>-->
<!--                        </li>-->
<!--                        <li class="position-relative">-->
<!--                            <div class="icon rounded-circle d-flex align-items-center justify-content-center position-absolute text-center transition">-->
<!--                                <i class="material-symbols-outlined">-->
<!--                                    person-->
<!--                                </i>-->
<!--                            </div>-->
<!--                            <span class="sub-title d-block">-->
<!--                                <strong class="fw-semibold">A new user</strong> added in Trinta-->
<!--                            </span>-->
<!--                            <span class="time d-block text-body">-->
<!--                                3 hrs ago-->
<!--                            </span>-->
<!--                            <a routerLink="/notifications" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                            <span class="unread d-inline-block rounded-circle bg-primary position-absolute"></span>-->
<!--                        </li>-->
<!--                        <li class="position-relative">-->
<!--                            <div class="icon rounded-circle d-flex align-items-center justify-content-center position-absolute text-center transition">-->
<!--                                <i class="material-symbols-outlined">-->
<!--                                    mark_email_unread-->
<!--                                </i>-->
<!--                            </div>-->
<!--                            <span class="sub-title d-block">-->
<!--                                You have requested to <strong class="fw-semibold">withdrawal</strong>-->
<!--                            </span>-->
<!--                            <span class="time d-block text-body">-->
<!--                                1 day ago-->
<!--                            </span>-->
<!--                            <a routerLink="/notifications" class="d-block left-0 top-0 bottom-0 right-0 z-1 position-absolute"></a>-->
<!--                        </li>-->
<!--                    </ul>-->
<!--                    <div class="menu-footer text-center">-->
<!--                        <a routerLink="/notifications" class="text-primary text-decoration-underline d-inline-block fw-medium">-->
<!--                            See All Notifications-->
<!--                        </a>-->
<!--                    </div>-->
<!--                </mat-menu>-->
<!--            </li>-->
            <li>
                <div class="date-btn position-relative">
                    <i-feather name="calendar"></i-feather> {{ formattedDate }}
                </div>
            </li>
            
<!--            <li>-->
<!--                <button mat-button [matMenuTriggerFor]="languageMenu" class="language-menu-btn">-->
<!--                    <img src="./images/flags/{{ currentLang === 'en' ? 'eng' : 'spn' }}.svg" alt="flag"> {{ currentLang === 'en' ? 'ENG' : 'SPN' }}-->
<!--                </button>-->
<!--                <mat-menu class="language-menu-dropdown" #languageMenu="matMenu" xPosition="before">-->
<!--                    <span class="title fw-medium fs-16 d-block">-->
<!--                        {{ 'HEADER.CHOOSE_LANGUAGE' | translate }}-->
<!--                    </span>-->
<!--                        <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">-->
<!--                            <li>-->
<!--                            <button mat-button (click)="setLanguage('en')" [class.active]="currentLang === 'en'">-->
<!--                                <img src="./images/flags/eng.svg" alt="flag">-->
<!--                                    ENG-->
<!--                                </button>-->
<!--                            </li>-->
<!--                            <li>-->
<!--                            <button mat-button (click)="setLanguage('es')" [class.active]="currentLang === 'es'">-->
<!--                                <img src="./images/flags/spn.svg" alt="flag">-->
<!--                                    SPN-->
<!--                                </button>-->
<!--                            </li>-->
<!--                        </ul>-->
<!--                </mat-menu>-->
<!--            </li>-->
<!--            -->
            <li>
                <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
                    <div class="menu-header d-flex align-items-center">
                        <div class="user-icon-container">
                            <i-feather name="user" class="user-icon"></i-feather>
                        </div>
                        <div class="title">
                            <div class="user-email d-block fw-medium">
                                {{ getUserEmail() }}
                            </div>
                            <div class="user-role d-block text-body">
                                {{ getRoleTranslation() }}
                            </div>
                        </div>
<!--                        <div class="title">-->
<!--                            <a routerLink="/my-profile" class="d-inline-block fw-medium">-->
<!--                                {{ getUserEmail() }}-->
<!--                            </a>-->
<!--                            <span class="designation d-block text-body">-->
<!--                                {{ getRoleTranslation() }}-->
<!--                            </span>-->
<!--                        </div>-->
                    </div>
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                        <li class="position-relative transition fw-medium">
                            <i class="material-symbols-outlined">
                                logout
                            </i>
                            {{ 'LOGOUT' | translate }}
                            <a (click)="logout()" class="link-btn d-block position-absolute left-0 right-0 top-0 bottom-0 z-1">
                            </a>
                        </li>
                    </ul>
                </mat-menu>
            </li>
        </ul>
    </div>
</div>
